var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerlogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 202.997,
    height: 239.866,
    viewBox: "0 0 202.997 239.866",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8343",
    "data-name": "Rectangle 8343",
    width: 202.997,
    height: 239.866,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57204",
    "data-name": "Path 57204",
    d: "M64.956,20.832A193.135,193.135,0,0,1,6.342,32.185V104.61a137.076,137.076,0,0,0,74.271,121.84l21,10.826,21-10.825a137.077,137.077,0,0,0,74.27-121.841V32.185a177.711,177.711,0,0,1-65.636-13.767,174.59,174.59,0,0,1-29.2-15.733,192.256,192.256,0,0,1-37.1,18.147",
    transform: "translate(-6.342 -2.685)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.069,
    y1: 1.124,
    x2: 0.073,
    y2: 1.124,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f06f38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#ee6d36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea6632"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8336",
    "data-name": "Rectangle 8336",
    width: 177.207,
    height: 111.428,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57205",
    "data-name": "Path 57205",
    d: "M189.932,125.067V42.482a213.321,213.321,0,0,1-62.4-15.732,212.235,212.235,0,0,1-25.962-13.114A232.18,232.18,0,0,1,66.449,29.775,232.02,232.02,0,0,1,12.725,42.232v82.834Z",
    transform: "translate(-12.725 -13.636)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8341",
    "data-name": "Rectangle 8341",
    width: 127.356,
    height: 25.91,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38760",
    "data-name": "Group 38760",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38747",
    "data-name": "Group 38747",
    transform: "translate(6.409 2.713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38746",
    "data-name": "Group 38746",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8334",
    "data-name": "Rectangle 8334",
    width: 235.844,
    height: 192.085,
    transform: "translate(-1.544 234.582) rotate(-89.622)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38754",
    "data-name": "Group 38754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38753",
    "data-name": "Group 38753",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38752",
    "data-name": "Group 38752",
    transform: "translate(12.86 13.78)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38751",
    "data-name": "Group 38751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38750",
    "data-name": "Group 38750",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38749",
    "data-name": "Group 38749",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38748",
    "data-name": "Group 38748",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_8335",
    "data-name": "Rectangle 8335",
    width: 178.873,
    height: 112.175,
    transform: "translate(-0.733 -0.285)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALEAAABvCAYAAACjHSGaAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAI4SURBVHhe7d3h5hAGGMXhf938tijb2JakpmjT2Gaj1IyVopSolGiaWEosZSObZutwbuLwPF/ecwG/7++h/947gGGHe2GWiJknYuaJmHkiZp6ImSdi5omYeSJmnoiZJ2LmiZh5ImaeiJknYuaJmHkiZp6ImSdi5omYeSJmnoiZJ2LmiZh5ImaeiJknYuaJmHkiZp6ImSdi5omYeSJmnoiZJ2LmiZh5ImZevif92w2TEvG7bpiUiP/phkmJ+O9umJSI33bDpET8VzdMSsR/dsOkRPymGyYl4tfdMCkRv+qGSYn4j26YlIhfdsOkRPyiGyYl4ufdMCkRP+uGSYn4926YlIifdsOkRPxbN0xKxE+6YVIi/rUbJiXix90wKRE/6oZJifhhN0xKxA+6YVIivt8NkxLxvW6YlIjvdsOkRHynGyYl4tvdMCkR3+qGSYn4ZjdMSsQ3umFSIr7eDZMS8bVumJSIr3bDpER8pRsmJeJfumFSIv65GyYl4p+6YVIivtwNkxLxpW6YlIgvdsOkRHyhGyYl4h+7YVIi/qEbJiXi77thUiL+rhsmJeJvu2FSIv6mGyYl4vPdMCkRf90NkxLxV90wKRGf64ZJifhsN0xKxGe6YVIi/rIbJiXi090wKRGf6oZJifhkN0xKxCe6YVIiPt4NkxLxF90wKRF/3g2TEvFn3TApEX/aDZMS8SfdMCkRf9wNkxLxsW6YlIiPdsOkRHykGyYl4o+6YVIi/rAbJiXiD7ph0MHB/+oGFZPvCXoZAAAAAElFTkSuQmCC"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_57206",
    "data-name": "Path 57206",
    d: "M101.422,239.866,79.377,228.5a138.833,138.833,0,0,1-75.5-123.864V30.014l2.192-.081A190.626,190.626,0,0,0,63.988,18.716,190.368,190.368,0,0,0,100.647.788L101.9,0l1.227.821a172.691,172.691,0,0,0,28.816,15.528,174.7,174.7,0,0,0,64.8,13.589l2.233.042v74.659a138.833,138.833,0,0,1-75.5,123.864ZM8.428,34.4v70.244A134.294,134.294,0,0,0,81.464,224.457l19.959,10.289,19.958-10.289a134.294,134.294,0,0,0,73.036-119.818V34.433a178.93,178.93,0,0,1-64.243-13.889A177.251,177.251,0,0,1,101.826,5.42,194.941,194.941,0,0,1,65.538,23,195.11,195.11,0,0,1,8.428,34.4",
    transform: "translate(0.041)",
    fill: "#434db8"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_57237",
    "data-name": "Path 57237",
    d: "M3.377-8.1V-6.04H6.706v1.92H3.377v2.238H7.142V.108H.892V-10.1h6.25v1.992ZM15.007.108,12.926-3.017,11.1.108H8.277l3.27-5.189L8.2-10.1H11.1l2.049,3.081,1.8-3.081h2.821L14.527-4.95,17.9.108Zm3.721-5.117a5.485,5.485,0,0,1,.654-2.7,4.675,4.675,0,0,1,1.824-1.846,5.3,5.3,0,0,1,2.653-.661,5.076,5.076,0,0,1,3.111.959A4.607,4.607,0,0,1,28.7-6.636H25.963A2.207,2.207,0,0,0,25.1-7.61a2.431,2.431,0,0,0-1.272-.335,2.374,2.374,0,0,0-1.86.8,3.093,3.093,0,0,0-.707,2.136,3.093,3.093,0,0,0,.707,2.136,2.374,2.374,0,0,0,1.86.8A2.431,2.431,0,0,0,25.1-2.408a2.207,2.207,0,0,0,.865-.974h2.729A4.574,4.574,0,0,1,26.973-.771a5.1,5.1,0,0,1-3.111.952A5.3,5.3,0,0,1,21.21-.48a4.688,4.688,0,0,1-1.828-1.837,5.444,5.444,0,0,1-.654-2.691Zm13.984,3.2h3.255V.108H30.226V-10.1h2.486ZM39.605-10.1v6.1a2.021,2.021,0,0,0,.451,1.415,1.7,1.7,0,0,0,1.323.494,1.748,1.748,0,0,0,1.337-.494,1.98,1.98,0,0,0,.465-1.415v-6.1h2.486v6.091A4.33,4.33,0,0,1,45.086-1.7,3.723,3.723,0,0,1,43.523-.271,4.914,4.914,0,0,1,41.331.21a4.792,4.792,0,0,1-2.159-.472,3.522,3.522,0,0,1-1.5-1.425,4.548,4.548,0,0,1-.553-2.318V-10.1ZM51.1.21a5.249,5.249,0,0,1-2.006-.364A3.27,3.27,0,0,1,47.679-1.23a2.939,2.939,0,0,1-.56-1.718h2.646a1.283,1.283,0,0,0,.392.865,1.261,1.261,0,0,0,.872.3,1.364,1.364,0,0,0,.872-.255.851.851,0,0,0,.319-.707.835.835,0,0,0-.255-.626,2.053,2.053,0,0,0-.626-.4,10.055,10.055,0,0,0-1.054-.364,11.475,11.475,0,0,1-1.617-.606A2.981,2.981,0,0,1,47.6-5.652a2.511,2.511,0,0,1-.451-1.555,2.675,2.675,0,0,1,1.032-2.231,4.244,4.244,0,0,1,2.689-.808,4.29,4.29,0,0,1,2.718.808,2.888,2.888,0,0,1,1.1,2.246H52a1.052,1.052,0,0,0-.364-.778,1.28,1.28,0,0,0-.858-.283,1.069,1.069,0,0,0-.727.24.865.865,0,0,0-.276.69.856.856,0,0,0,.465.77,7.625,7.625,0,0,0,1.454.6,13.44,13.44,0,0,1,1.606.64,3.058,3.058,0,0,1,1.068.886,2.374,2.374,0,0,1,.451,1.5,2.938,2.938,0,0,1-.444,1.585A3.106,3.106,0,0,1,53.092-.211,4.4,4.4,0,0,1,51.1.21ZM58.833-10.1V.108H56.347V-10.1Zm11.382,0L66.6.108H63.486L59.866-10.1h2.646l2.526,7.7,2.547-7.7Zm3.518,1.992v2.065h3.329v1.92H73.734v2.238H77.5V.108H71.248V-10.1H77.5v1.992Z",
    transform: "translate(61.483 64.461)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57236",
    "data-name": "Path 57236",
    d: "M6.931-5.7a2.609,2.609,0,0,1-.318,1.26,2.336,2.336,0,0,1-1,.949,3.625,3.625,0,0,1-1.711.36H2.5V.089H.82v-8.38H3.905a3.729,3.729,0,0,1,1.656.337,2.342,2.342,0,0,1,1.027.925A2.6,2.6,0,0,1,6.931-5.7Zm-3.1,1.213A1.456,1.456,0,0,0,4.864-4.8,1.172,1.172,0,0,0,5.2-5.7q0-1.225-1.368-1.225H2.5v2.438ZM9.794-1.243h2.761V.089H8.108v-8.38H9.8Zm8.969-.264H15.428l-.55,1.6H13.114L16.127-8.3h1.953L21.1.089H19.321Zm-.456-1.345L17.094-6.357,15.882-2.852Zm9.617-5.439v1.356H25.69V.089H24.015V-6.934H21.782V-8.291Zm2.905,0V.089H29.154v-8.38ZM39.659.089H37.978L34.172-5.662V.089H32.492V-8.3h1.681l3.806,5.76V-8.3h1.681Zm3.314-8.38V-3.1a1.779,1.779,0,0,0,.445,1.3,1.676,1.676,0,0,0,1.249.451,1.692,1.692,0,0,0,1.26-.451,1.779,1.779,0,0,0,.445-1.3V-8.291h1.693v5.174A3.341,3.341,0,0,1,47.6-1.31,2.931,2.931,0,0,1,46.365-.2a3.925,3.925,0,0,1-1.718.372A3.821,3.821,0,0,1,42.941-.2a2.83,2.83,0,0,1-1.207-1.112,3.446,3.446,0,0,1-.445-1.807V-8.292Zm15.848,0V.089H57.14V-5.362L54.894.089H53.622L51.364-5.362V.089H49.684v-8.38h1.909L54.26-2.06l2.665-6.231ZM66.228.173a3.981,3.981,0,0,1-1.579-.3,2.592,2.592,0,0,1-1.112-.864,2.276,2.276,0,0,1-.42-1.333h1.8a1.164,1.164,0,0,0,.366.817,1.3,1.3,0,0,0,.91.3,1.4,1.4,0,0,0,.925-.282.918.918,0,0,0,.337-.739.853.853,0,0,0-.228-.612,1.6,1.6,0,0,0-.57-.378,9.438,9.438,0,0,0-.943-.3A10.093,10.093,0,0,1,64.387-4a2.324,2.324,0,0,1-.876-.707,2.021,2.021,0,0,1-.368-1.271,2.265,2.265,0,0,1,.372-1.3,2.367,2.367,0,0,1,1.045-.847A3.8,3.8,0,0,1,66.1-8.412a3.335,3.335,0,0,1,2.107.631A2.336,2.336,0,0,1,69.1-6.023H67.249a.96.96,0,0,0-.366-.714,1.379,1.379,0,0,0-.91-.282,1.167,1.167,0,0,0-.786.252.91.91,0,0,0-.294.733.757.757,0,0,0,.222.558,1.694,1.694,0,0,0,.552.36q.33.138.931.318a9.775,9.775,0,0,1,1.333.48,2.393,2.393,0,0,1,.888.721,2,2,0,0,1,.374,1.262,2.371,2.371,0,0,1-.349,1.249,2.458,2.458,0,0,1-1.021.919,3.48,3.48,0,0,1-1.6.342Zm6.1-7.107v2.1h2.822V-3.5H72.327v2.223h3.181V.089H70.646V-8.3h4.862v1.364ZM81.355.089,79.506-3.176h-.79V.089H77.033v-8.38h3.146a3.673,3.673,0,0,1,1.656.343,2.39,2.39,0,0,1,1.024.924,2.527,2.527,0,0,1,.343,1.3,2.5,2.5,0,0,1-.48,1.495,2.467,2.467,0,0,1-1.429.919L83.3.089Zm-2.64-4.526h1.4a1.4,1.4,0,0,0,1.021-.33,1.229,1.229,0,0,0,.337-.919,1.172,1.172,0,0,0-.337-.894A1.437,1.437,0,0,0,80.12-6.9h-1.4ZM92.258-8.291,89.183.089H87.142l-3.07-8.38h1.8l2.3,6.662,2.293-6.664Zm2.689,0V.089H93.268v-8.38ZM96.2-4.113a4.39,4.39,0,0,1,.558-2.215,3.987,3.987,0,0,1,1.525-1.525,4.326,4.326,0,0,1,2.162-.547,4.263,4.263,0,0,1,2.461.721,3.766,3.766,0,0,1,1.48,1.994h-1.933a2,2,0,0,0-.808-.9,2.378,2.378,0,0,0-1.207-.3,2.482,2.482,0,0,0-1.3.343,2.335,2.335,0,0,0-.888.966,3.186,3.186,0,0,0-.318,1.464,3.2,3.2,0,0,0,.318,1.458,2.324,2.324,0,0,0,.888.972,2.482,2.482,0,0,0,1.3.343,2.342,2.342,0,0,0,1.207-.3,2.039,2.039,0,0,0,.808-.91h1.933a3.746,3.746,0,0,1-1.47,2,4.281,4.281,0,0,1-2.471.718,4.326,4.326,0,0,1-2.167-.547A4,4,0,0,1,96.752-1.9,4.357,4.357,0,0,1,96.2-4.113ZM107.5-6.934v2.1h2.822V-3.5H107.5v2.223h3.181V.089h-4.862V-8.3h4.862v1.364ZM121.179-5.7a2.609,2.609,0,0,1-.318,1.26,2.336,2.336,0,0,1-1,.949,3.625,3.625,0,0,1-1.711.36h-1.4V.089h-1.681v-8.38h3.085a3.729,3.729,0,0,1,1.656.337,2.342,2.342,0,0,1,1.027.925,2.6,2.6,0,0,1,.343,1.332Zm-3.1,1.213a1.456,1.456,0,0,0,1.033-.318,1.172,1.172,0,0,0,.337-.894q0-1.225-1.368-1.225H116.75v2.438Zm9.425,2.977h-3.335l-.556,1.6h-1.764L124.865-8.3h1.954L129.835.089h-1.777Zm-.456-1.345-1.213-3.506-1.213,3.506ZM135.286.089l-1.849-3.265h-.792V.089h-1.682v-8.38h3.146a3.673,3.673,0,0,1,1.656.343,2.39,2.39,0,0,1,1.027.925,2.526,2.526,0,0,1,.343,1.3,2.5,2.5,0,0,1-.48,1.495,2.467,2.467,0,0,1-1.429.919l2,3.4Zm-2.642-4.526h1.4a1.4,1.4,0,0,0,1.021-.33,1.229,1.229,0,0,0,.34-.918,1.172,1.172,0,0,0-.337-.894,1.437,1.437,0,0,0-1.021-.318h-1.4Zm11.723-3.854v1.357h-2.233V.089h-1.681V-6.934H138.22V-8.291ZM152.755.089h-1.682l-3.806-5.751V.089h-1.681V-8.3h1.681l3.806,5.76V-8.3h1.681Zm3.335-7.024v2.1h2.822V-3.5H156.09v2.223h3.181V.089h-4.863V-8.3h4.862v1.364ZM165.121.089l-1.849-3.265h-.792V.089H160.8v-8.38h3.146a3.673,3.673,0,0,1,1.656.343,2.39,2.39,0,0,1,1.027.925,2.526,2.526,0,0,1,.343,1.3,2.5,2.5,0,0,1-.48,1.495,2.467,2.467,0,0,1-1.429.919l2,3.4Zm-2.642-4.526h1.4a1.4,1.4,0,0,0,1.021-.33,1.229,1.229,0,0,0,.337-.919,1.172,1.172,0,0,0-.337-.894,1.437,1.437,0,0,0-1.021-.318h-1.4Z",
    transform: "translate(18.295 80.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38759",
    "data-name": "Group 38759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38758",
    "data-name": "Group 38758",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8338",
    "data-name": "Rectangle 8338",
    width: 202.997,
    height: 45.855,
    transform: "translate(0 92.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57207",
    "data-name": "Path 57207",
    d: "M9.777,143.378,0,136.979H8.028Z",
    transform: "translate(0 1.45)",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57208",
    "data-name": "Path 57208",
    d: "M191.2,143.378l9.777-6.4h-8.028Z",
    transform: "translate(2.024 1.45)",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57209",
    "data-name": "Path 57209",
    d: "M53.147,128.187H43.973l-9.35-9.352-4.505,4.5v-8.983l.013-.009,4.585-4.589,3.811-3.81,4.491,4.491-3.81,3.811Z",
    transform: "translate(0.319 1.121)",
    fill: "#f70",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57210",
    "data-name": "Path 57210",
    d: "M57.6,105.345v8.986l-8.405,8.4-4.493-4.488,1.523-1.523,2.285-2.284L34.575,100.5h9.174l9.354,9.354Z",
    transform: "translate(0.366 1.064)",
    fill: "#036",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57211",
    "data-name": "Path 57211",
    d: "M78.032,104.788v2.587H74.269V118.2h-2.8V107.376h-3.8v-2.587Z",
    transform: "translate(0.716 1.109)",
    fill: "#f70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57212",
    "data-name": "Path 57212",
    d: "M87.014,113.091a5.648,5.648,0,0,1-.08,1.055H80.77q.258,2.008,1.95,2.009a1.509,1.509,0,0,0,1.593-1.034h2.478A4.437,4.437,0,0,1,79.339,117a5.214,5.214,0,0,1-1.224-3.651,5.373,5.373,0,0,1,1.243-3.732,4.29,4.29,0,0,1,3.354-1.382,3.947,3.947,0,0,1,3.154,1.324A5.21,5.21,0,0,1,87.01,113.1m-4.358-2.729q-1.573,0-1.872,1.93h3.6a2.278,2.278,0,0,0-.477-1.415,1.553,1.553,0,0,0-1.253-.517",
    transform: "translate(0.827 1.145)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57213",
    "data-name": "Path 57213",
    d: "M92.165,118.345a4.466,4.466,0,0,1-2.947-.867,3.32,3.32,0,0,1-1.134-2.458h2.507q.061,1.176,1.552,1.174a1.958,1.958,0,0,0,1.066-.248.746.746,0,0,0,.387-.648.782.782,0,0,0-.537-.7,5.975,5.975,0,0,0-1.3-.427q-.767-.171-1.532-.418a2.881,2.881,0,0,1-1.3-.867,2.324,2.324,0,0,1-.538-1.591,2.747,2.747,0,0,1,1.011-2.239,4.865,4.865,0,0,1,5.423,0,3.032,3.032,0,0,1,1.073,2.278H93.4a1.155,1.155,0,0,0-1.295-1.011,1.469,1.469,0,0,0-.865.219.676.676,0,0,0-.309.577.763.763,0,0,0,.538.685,5.955,5.955,0,0,0,1.3.4,14.276,14.276,0,0,1,1.533.409,2.782,2.782,0,0,1,1.3.9,2.51,2.51,0,0,1,.537,1.661,2.8,2.8,0,0,1-1.065,2.318,4.564,4.564,0,0,1-2.915.846",
    transform: "translate(0.932 1.145)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57214",
    "data-name": "Path 57214",
    d: "M102.9,110.6h-1.99v4.637a.927.927,0,0,0,.238.728,1.314,1.314,0,0,0,.856.208h.7v1.867a5.753,5.753,0,0,1-1.572.238,2.654,2.654,0,0,1-1.981-.717,2.887,2.887,0,0,1-.707-2.11v-4.856H96.921v-2.148h1.516v-3.364h2.469v3.364h1.99Z",
    transform: "translate(1.026 1.112)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57215",
    "data-name": "Path 57215",
    d: "M112.123,104.788h3.065l-4.518,8V118.2h-2.805v-5.418l-4.518-8h3.065l2.846,5.457Z",
    transform: "translate(1.094 1.109)",
    fill: "#f70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57216",
    "data-name": "Path 57216",
    d: "M123.745,116.1h.458v1.971a3.485,3.485,0,0,1-1.1.18,2.131,2.131,0,0,1-1.929-.917,3.833,3.833,0,0,1-2.707,1.011,3.419,3.419,0,0,1-2.846-1.354,6.855,6.855,0,0,1,.05-7.382,3.515,3.515,0,0,1,2.876-1.373,2.985,2.985,0,0,1,2.288.936l.061-.756h2.368v6.925a1.164,1.164,0,0,0,.109.588.4.4,0,0,0,.369.168m-4.8-.019q1.831,0,1.831-2.83,0-2.747-1.791-2.746-1.831,0-1.831,2.805,0,2.767,1.791,2.767",
    transform: "translate(1.213 1.145)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57217",
    "data-name": "Path 57217",
    d: "M130.733,108.235a2.919,2.919,0,0,1,2.387.985,4.4,4.4,0,0,1,.816,2.874v6.071h-2.567v-5.891q0-1.772-1.372-1.771a1.5,1.5,0,0,0-1.294.636,3.19,3.19,0,0,0-.458,1.872v5.154h-2.567v-9.75h2.448l.04.735a3.638,3.638,0,0,1,2.568-.91",
    transform: "translate(1.33 1.145)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57218",
    "data-name": "Path 57218",
    d: "M141.163,110.6h-1.99v4.637a.927.927,0,0,0,.238.728,1.314,1.314,0,0,0,.856.208h.7v1.867a5.753,5.753,0,0,1-1.572.238,2.654,2.654,0,0,1-1.981-.716,2.887,2.887,0,0,1-.707-2.11v-4.856h-1.516v-2.148H136.7v-3.364h2.469v3.364h1.991Z",
    transform: "translate(1.431 1.112)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57219",
    "data-name": "Path 57219",
    d: "M147.645,108.235a1.837,1.837,0,0,1,.775.139v2.308h-1.033q-2.012,0-2.011,2.846v4.637h-2.567v-9.75h2.447l.08,1.193a3.125,3.125,0,0,1,1.026-1,2.462,2.462,0,0,1,1.283-.378",
    transform: "translate(1.511 1.145)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57220",
    "data-name": "Path 57220",
    d: "M158.167,116.1h.458v1.971a3.485,3.485,0,0,1-1.1.18,2.131,2.131,0,0,1-1.929-.917,3.833,3.833,0,0,1-2.707,1.011,3.419,3.419,0,0,1-2.846-1.354,6.855,6.855,0,0,1,.05-7.382,3.515,3.515,0,0,1,2.876-1.373,2.985,2.985,0,0,1,2.288.936l.061-.756h2.37v6.925a1.164,1.164,0,0,0,.109.588.4.4,0,0,0,.369.168m-4.8-.019q1.831,0,1.831-2.83,0-2.747-1.791-2.746-1.831,0-1.831,2.805,0,2.767,1.791,2.767",
    transform: "translate(1.577 1.145)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57221",
    "data-name": "Path 57221",
    d: "M73.158,124.7h2.8v1.131a2.324,2.324,0,0,1-.613,1.663,2.386,2.386,0,0,1-1.824.654,2.33,2.33,0,0,1-1.911-.815,3.416,3.416,0,0,1-.666-2.223,3.335,3.335,0,0,1,.679-2.211,2.663,2.663,0,0,1,3.544-.253,2.2,2.2,0,0,1,.748,1.4H74.672a.93.93,0,0,0-.37-.639,1.23,1.23,0,0,0-.761-.231,1.155,1.155,0,0,0-1.011.5,2.5,2.5,0,0,0-.344,1.435q0,1.952,1.34,1.95a1.254,1.254,0,0,0,.9-.292.924.924,0,0,0,.309-.7v-.3H73.158Z",
    transform: "translate(0.751 1.292)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57222",
    "data-name": "Path 57222",
    d: "M82.35,126.923h2.489v1.131H81.12v-5.868h1.229Z",
    transform: "translate(0.859 1.293)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57223",
    "data-name": "Path 57223",
    d: "M91.994,128.151a2.284,2.284,0,0,1-1.889-.827,3.446,3.446,0,0,1-.661-2.212,3.311,3.311,0,0,1,.684-2.216,2.338,2.338,0,0,1,1.884-.808,2.277,2.277,0,0,1,1.907.847,3.928,3.928,0,0,1-.008,4.374,2.308,2.308,0,0,1-1.92.841m.014-1.1a1.129,1.129,0,0,0,1-.505,3.2,3.2,0,0,0,.008-2.852,1.112,1.112,0,0,0-1-.505,1.135,1.135,0,0,0-.987.489,2.49,2.49,0,0,0-.345,1.445,2.563,2.563,0,0,0,.337,1.433,1.112,1.112,0,0,0,.989.5",
    transform: "translate(0.947 1.292)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57224",
    "data-name": "Path 57224",
    d: "M103.465,125.007a1.558,1.558,0,0,1,.279,2.581,2.135,2.135,0,0,1-1.435.466H99.681v-5.868h2.544a2.088,2.088,0,0,1,1.389.428,1.426,1.426,0,0,1,.505,1.156,1.358,1.358,0,0,1-.654,1.237m-.565-1.112a.57.57,0,0,0-.188-.452.748.748,0,0,0-.517-.166h-1.288v1.247h1.341a.658.658,0,0,0,.475-.175.606.606,0,0,0,.178-.453m-.558,3.074a.707.707,0,0,0,.519-.192.666.666,0,0,0,.2-.5.639.639,0,0,0-.222-.512.863.863,0,0,0-.587-.192h-1.341v1.394Z",
    transform: "translate(1.055 1.293)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57225",
    "data-name": "Path 57225",
    d: "M113.078,128.053l-.479-1.314h-2.081l-.479,1.314h-1.271L111,122.185h1.123l2.228,5.868Zm-2.16-2.411h1.288l-.645-1.785Z",
    transform: "translate(1.151 1.293)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57226",
    "data-name": "Path 57226",
    d: "M120.283,126.923h2.49v1.131h-3.719v-5.868h1.229Z",
    transform: "translate(1.26 1.293)",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38757",
    "data-name": "Group 38757",
    transform: "translate(40.091 153.983)",
    opacity: 0.42
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38756",
    "data-name": "Group 38756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38755",
    "data-name": "Group 38755",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57227",
    "data-name": "Path 57227",
    d: "M72.247,161.928v2.719h5.44v2.72h-5.44v4.244H68.731v-12.4h9.685v2.717H72.252Z",
    transform: "translate(-39.363 -152.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8339",
    "data-name": "Rectangle 8339",
    width: 3.516,
    height: 12.339,
    transform: "translate(40.911 6.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57228",
    "data-name": "Path 57228",
    d: "M91.567,168.3h-1.92v3.251h-3.52v-12.34h5.639c3.383,0,5.507,1.725,5.507,4.578a4.121,4.121,0,0,1-2.388,3.913l2.655,3.847H93.823Zm.067-6.367h-1.92v3.583h1.92c1.459,0,2.189-.664,2.189-1.792-.067-1.061-.73-1.791-2.189-1.791",
    transform: "translate(-39.179 -152.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57229",
    "data-name": "Path 57229",
    d: "M109.142,168.832v2.719H99.257V159.212h9.685v2.716h-6.236v2.056h5.506v2.593h-5.506v2.256Z",
    transform: "translate(-39.04 -152.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57230",
    "data-name": "Path 57230",
    d: "M114.589,161.928v2.719h5.44v2.72h-5.44v4.244h-3.516v-12.4h9.685v2.717h-6.165Z",
    transform: "translate(-38.915 -152.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57231",
    "data-name": "Path 57231",
    d: "M122.43,159.212h3.516v9.553h5.9v2.786H122.5V159.212Z",
    transform: "translate(-38.795 -152.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8340",
    "data-name": "Rectangle 8340",
    width: 3.516,
    height: 12.339,
    transform: "translate(94.58 6.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57232",
    "data-name": "Path 57232",
    d: "M151.043,159.212v12.339h-2.85l-5.44-6.569v6.569H139.3V159.212h2.853l5.44,6.569v-6.569Z",
    transform: "translate(-38.617 -152.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57233",
    "data-name": "Path 57233",
    d: "M158.256,167.107l-1.328,1.394v3.118H153.48V159.212h3.449v5.107l4.776-5.107h3.848l-5.042,5.44,5.31,6.9h-4.042Z",
    transform: "translate(-38.467 -152.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57234",
    "data-name": "Path 57234",
    d: "M48.633,155.007c-.331.2-.6.331-.862.465-1,.531-1.92.994-2.92,1.526a.4.4,0,0,0-.2.4v20.1c0,.265-.066.464-.33.531a3.324,3.324,0,0,1-3.052-.266,3.071,3.071,0,0,1-1.258-1.99,17.756,17.756,0,0,1-.2-3.25c-.067-5.31-.132-10.681-.132-15.988a5.08,5.08,0,0,1,.465-2.454,2.97,2.97,0,0,1,3.516-1.593,9.756,9.756,0,0,1,2.655,1.257c.73.4,1.46.8,2.122,1.195.062-.066.127,0,.194.068",
    transform: "translate(-39.671 -152.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57235",
    "data-name": "Path 57235",
    d: "M48.671,175.389v-5.771a.473.473,0,0,1,.2-.4c2.257-1.258,4.511-2.521,6.7-3.782.6-.332,1.195-.664,1.857-1.061a10.6,10.6,0,0,0-1.195-.663c-.994-.6-1.99-1.128-2.985-1.725a.292.292,0,0,0-.331,0c-1.258.8-2.455,1.525-3.716,2.324-.067,0-.067.067-.132.067v-4.244a.606.606,0,0,1,.2-.465c1.128-.8,2.256-1.526,3.317-2.324a.423.423,0,0,1,.4,0c1.525.862,3.118,1.792,4.643,2.655,1.062.6,2.122,1.195,3.251,1.792a4.711,4.711,0,0,1,1.92,1.857,2.805,2.805,0,0,1-.4,3.251,6.448,6.448,0,0,1-1.857,1.459c-1.526.863-2.985,1.792-4.511,2.656-1.92,1.127-3.782,2.189-5.706,3.317-.6.394-1.127.727-1.657,1.058",
    transform: "translate(-39.576 -152.318)",
    fill: "#fff"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerlogo2);
export default __webpack_public_path__ + "static/media/partnerlogo2.cfb33fa0b547ef651a7fba3cfb158dc7.svg";
export { ForwardRef as ReactComponent };